export enum BannerType {
  info = 'info',
  warning = 'warning',
  error = 'error',
  success = 'success',
}
